import { useApi } from '@/composables/use-api'
import type { UserNotificationSetting } from './types'

export async function fetchNotificationSettings() {
  const { abaSupportAPI } = useApi()
  const { data } = await abaSupportAPI.notifications.getSettings()
  return data.groups
}

export async function updateNotificationSettings(
  settings: UserNotificationSetting[],
) {
  const { abaSupportAPI } = useApi()
  const { data } = await abaSupportAPI.notifications.updateSettings(settings)
  return data
}
